import { ActionFormat } from '../actions/actionFormats'
import * as actionTypes from '../actionTypes/notificationActionTypes'

import { NotificationState } from '../types/notification'

// default state (we export it for tests)
export const defaultState: NotificationState = {
  msg: '',
  type: '',
  isOpen: false,
}

/**
 * Notification reducer
 * @param state
 * @param action
 * @returns {*}
 */
const notificationReducer = (
  state: NotificationState = defaultState,
  action: ActionFormat,
): NotificationState => {
  switch (action.type) {
    //-----------------------------------------------------------------
    case actionTypes.SHOW_NOTIFICATION_SUCCESS:
      return {
        ...state,
        msg: action.payload,
        type: 'success',
      }

    //-----------------------------------------------------------------
    case actionTypes.SHOW_NOTIFICATION_ERROR:
      return {
        ...state,
        msg: action.payload,
        type: 'error',
      }

    //-----------------------------------------------------------------
    case actionTypes.HIDE_NOTIFICATION:
      return {
        ...state,
        msg: '',
        type: '',
      }

    //-----------------------------------------------------------------
    default:
      return state
  } // end switch
}

export default notificationReducer
